__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/f039a7488b992e1ea515d2b44a2f14de241030b1/_next/";